<template>
  <div class="content" v-if="rendered">
    <div class="row">
      <div class="col-12">
        <full-calendar
          id="fullCalendar"
          v-bind="calendarOptions"
          :events="events"
          contentHeight="auto"
          ref="fullCalendar"
          @select="onSelect"
        />
      </div>
    </div>
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">
        Criar Evento
      </h4>
      <div class="row text-left">
        <base-input
          name="Titulo"
          v-model="novoEvento.titulo"
          placeholder="Título"
          addon-left-icon="tim-icons icon-pencil"
        >
        </base-input>
      </div>
      <div class="row text-left">
        <el-select
          class="select-primary"
          size="large"
          placeholder="Restaurante"
          :disabled="!admin"
          v-model="novoEvento.restaurante"
        >
          <el-option
            v-for="option in restaurantes"
            class="select-primary"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>
      </div>
      <div class="row text-center mt-3">
        <div class="col-6">
          <base-button
            native-type="submit"
            type="primary"
            class="mb-3"
            size="lg"
            block
            @click="criarEvento"
          >
            Criar Evento
          </base-button>
        </div>
      </div>
    </modal>
  </div>
  <div v-else>
    <div class="loading-overlay">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Select, Option } from "element-ui";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import api from "../api/index";
import { Modal, BaseInput } from "@/components/index";
const today = new Date();
const y = today.getFullYear();
const m = today.getMonth();
const d = today.getDate();
export default {
  components: {
    FullCalendar,
    Modal,
    BaseInput,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      rendered: false,
      events: [],
      modals: {
        classic: false,
      },
      user: [],
      restaurantes: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        theme: true,
        defaultView: "dayGridMonth",
        header: {
          left: "title",
          center: "dayGridMonthy",
          right: "prev,next,today",
        },
        defaultDate: today,
        selectable: true,
        selectHelper: true,
        views: {
          month: {
            titleFormat: {
              month: "long",
              year: "numeric",
            },
          },
        },
        editable: false,
        eventLimit: true,
        events: self.events,
        locale: "pt",
      },
      dataParaEventos: {
        start: "",
        end: "",
      },
      novoEvento: {
        data_inicio: "",
        data_fim: "",
        restaurante: "",
        titulo: "",
      },
      admin: "0",
    };
  },
  methods: {
    notifyVue(verticalAlign, horizontalAlign, color, mensagem) {
      this.$notify({
        icon: "tim-icons icon-bell-55",
        message: mensagem,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: color,
        timeout: 2000,
      });
    },

    async criarEvento() {
      if (
        this.novoEvento.titulo.trim() == "" ||
        this.novoEvento.restaurante.trim() == ""
      ) {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Tem de preencher todos os campos"
        );
        return;
      }
      let res = await api.criarEvento(this.novoEvento);
      if (res.resultado == "OK") {
        this.events.push({
          start: this.dataParaEventos.start,
          end: this.dataParaEventos.end,
          url: "",
          className: "event-orange",
          title: this.novoEvento.titulo,
        });
        this.notifyVue("top", "right", "success", "O evento foi criado");
        this.novoEvento = {
          data_inicio: "",
          data_fim: "",
          restaurante: "",
          titulo: "",
        };
        this.modals.classic = false;
        return;
      } else {
        this.notifyVue(
          "top",
          "right",
          "warning",
          "Ocorreu um erro, por favor tente mais tarde"
        );
        return;
      }
    },

    formatarDataEvento(data) {
      // Extrai o ano, mês e dia considerando o fuso horário local
      var ano = data.getFullYear();
      var mes = String(data.getMonth() + 1).padStart(2, "0"); // getMonth() retorna o mês de 0-11, então adicionamos 1
      var dia = String(data.getDate()).padStart(2, "0"); // getDate() retorna o dia do mês

      // Formata a data no formato yyyy-mm-dd
      var dataFormatada = `${ano}-${mes}-${dia}`;
      return dataFormatada;
    },

    async inicio() {
      this.rendered = false;

      var user = JSON.parse(localStorage.getItem("appGerenciaLogin"));
      let resUser = await api.listarRestaurante({
        user_id: user.user_id,
      });
      this.user = user;
      this.admin = resUser.resultado.admin == "1" ? true : false;
      // this.calendarOptions.selectable = this.admin;
      var json = {
        restaurante: user.nome,
        admin: resUser.resultado.admin,
      };
      let res = await api.listarEventos(json);
      var eventos = Object.values(res.resultado);
      const classesDisponiveis = [
        "event-azure",
        "event-green",
        "event-orange",
        "event-red",
        "event-rose",
        "event-default",
      ];
      if (eventos.length > 0) {
        const eventosParaFullCalendar = eventos.map((evento) => {
          // Seleciona uma classe aleatória
          const classeAleatoria =
            classesDisponiveis[
              Math.floor(Math.random() * classesDisponiveis.length)
            ];

          return {
            title: this.admin
              ? evento.restaurante + " " + evento.titulo
              : evento.titulo,
            start: new Date(evento.data_inicio),
            end: new Date(evento.data_fim),
            url: "",
            className: classeAleatoria, // Atribui a classe aleatória
          };
        });

        this.events = eventosParaFullCalendar;
      }
      // IR BUSCAR RESTAURANTES
      var resRestaurantes = await api.listarRestaurantes();
      var tempRest = Object.values(resRestaurantes.resultado);
      for (let i = 0; i < tempRest.length; i++) {
        this.restaurantes.push({
          label: tempRest[i].nome,
          value: tempRest[i].nome,
        });
      }
      this.restaurantes.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      this.rendered = true;
    },

    async onSelect({ start, end }) {
      if (!this.admin) {
        this.novoEvento.restaurante = this.user.nome;
        console.log(this.user.nome);
      }
      this.dataParaEventos.start = start;

      // Subtrai uma hora de 'end'
      const endAdjusted = new Date(end.getTime() - 60 * 60 * 1000); // Subtrai 1 hora

      this.dataParaEventos.end = endAdjusted; // Agora tem uma hora a menos

      this.novoEvento.data_inicio = this.formatarDataEvento(start);
      this.novoEvento.data_fim = this.formatarDataEvento(endAdjusted); // Usa a data ajustada

      console.log(this.novoEvento);
      this.modals.classic = true;
    },
  },
  async mounted() {
    await this.inicio();
  },
};
</script>
<style>
#fullCalendar {
  min-height: 400px;
}

.el-loading-spinner .path {
  stroke: #66615b !important;
}
</style>
